<template>
  <div class="row-wrapper">
    <div class="feature-name">
      <div class="name">
        {{ locales(feature.locale) }}
        <tippy
          v-if="hasTooltip"
          theme="payment-plans"
          :arrow="false"
          placement="right"
          :max-width="tooltipMaxWidth"
          :on-show="onTippyShow"
          :on-hide="onTippyHide"
          :flip="true"
          :popper-options="{
            modifiers: [
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['right-end'],
                },
              },
            ],
          }"
        >
          <template #default>
            <svgImage :name="'pricing-table-modal-icon'" />
          </template>

          <template #content>
            <div class="payment-plans__tooltip-outer">
              <span class="payment-plans__tooltip-arrow" />
              <div class="payment-plans__tooltip-wrap">
                <LottieAdapter
                  v-if="contentVisible"
                  :path="feature.lottie"
                  :width="tooltipLottieWidth"
                  :height="tooltipLottieHeight"
                  :show-preloader="true"
                />
              </div>
            </div>
          </template>
        </tippy>
      </div>
    </div>
    <div class="plans-access">
      <table-cell
        v-for="(plan, index) in plans"
        :key="index"
        :plan="plan"
        :feature="feature"
      />
    </div>
  </div>
</template>

<script>
import svgImage from '../../common/VueComponents/VueIcon/vgpSvgImage.vue';
import LottieAdapter from '../../tooltip/LottieAdapter.vue';
import tableCell from './tableCell.vue';

const TOOLTIP_PADDING = 8;
const TOOLTIP_LOTTIE_WIDTH = 499;
const TOOLTIP_LOTTIE_HEIGHT = 280;

export default {
  components: { tableCell, svgImage, LottieAdapter },
  props: ['plans', 'feature'],
  data() {
    return {
      locales: __,
      contentVisible: false,
    };
  },
  computed: {
    hasTooltip() {
      return !!this.feature.modal;
    },
    tooltipLottieWidth: () => TOOLTIP_LOTTIE_WIDTH,
    tooltipLottieHeight: () => TOOLTIP_LOTTIE_HEIGHT,
    tooltipMaxWidth: () => TOOLTIP_LOTTIE_WIDTH + TOOLTIP_PADDING * 2 + 5,
  },
  methods: {
    onTippyShow() {
      this.contentVisible = true;
    },
    onTippyHide() {
      this.contentVisible = false;
    },
  },
};
</script>

<style scoped src="../less/paymentPlans.less"></style>
<style lang="less">
@tooltip-padding: 8px;
@tooltip-lottie-w: 499px;
@tooltip-lottie-h: 280px;
@tooltip-bg: #191919;
@tooltip-arrow-size: 6px;

.tippy-box[data-theme~='payment-plans'] {
  background: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
  overflow: visible;

  .tippy-content {
    padding: 0;
    overflow: visible;
  }

  .tippy-arrow {
    display: none;
  }
}

.payment-plans__tooltip-outer {
  position: relative;
  box-sizing: border-box;
  width: calc(@tooltip-lottie-w + @tooltip-padding * 2);
  height: calc(@tooltip-lottie-h + @tooltip-padding * 2);
  padding: @tooltip-padding;
  background-color: @tooltip-bg;
  border-radius: 4px;
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.25));
  overflow: visible;

  .payment-plans__tooltip-wrap {
    width: 100%;
    height: 100%;
  }
}

.payment-plans__tooltip-wrap {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-plans__tooltip-arrow {
  position: absolute;
  left: -@tooltip-arrow-size;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: @tooltip-arrow-size solid transparent;
  border-bottom: @tooltip-arrow-size solid transparent;
  border-right: @tooltip-arrow-size solid @tooltip-bg;
  z-index: 10;
  pointer-events: none;
}

.tippy-box[data-placement='right-end'] .payment-plans__tooltip-arrow {
  top: auto;
  bottom: @tooltip-padding;
  transform: none;
}
</style>
